// styles/alertStyles.ts
import { cva } from 'class-variance-authority';

export const containerStyles = cva('rounded-md border p-2.5', {
  variants: {
    type: {
      WARNING: 'bg-yellow-50',
      INFO: 'bg-primary-background',
      ERROR: 'bg-red-50',
      SUCCESS: 'bg-green-50',
    },
  },
});

export const titleStyles = cva('text-sm font-medium', {
  variants: {
    type: {
      WARNING: 'text-yellow-800',
      INFO: 'text-secondary-700',
      ERROR: 'text-red-800',
      SUCCESS: 'text-green-800',
    },
  },
});

export const descriptionStyles = cva('text-sm', {
  variants: {
    type: {
      WARNING: 'text-yellow-700',
      INFO: 'text-tertiary-600',
      ERROR: 'text-red-700',
      SUCCESS: 'text-green-700',
    },
  },
});

export const actionButtonStyles = cva('rounded-md py-1.5 pl-0 pr-2 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2', {
  variants: {
    type: {
      WARNING: 'text-yellow-700 hover:bg-yellow-100 focus:ring-yellow-600 focus:ring-offset-yellow-50',
      INFO: 'text-brand-800 hover:bg-brand-100 focus:ring-brand-600 focus:ring-offset-brand-50',
      ERROR: 'text-red-800 hover:bg-red-100 focus:ring-red-600 focus:ring-offset-red-50',
      SUCCESS: 'text-green-800 hover:bg-green-100 focus:ring-green-600 focus:ring-offset-green-50',
    },
  },
});
